module.exports = "<p>\n  dialog-demo works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/dialog-demo/dialog-demo.component.html
// module id = ../../../../../src/app/dialog-demo/dialog-demo.component.html
// module chunks = main